import React from "react";
import { dangericon, error02 } from "../components/imagepath";
import { Link } from "react-router-dom";
import { useRouteError } from "react-router-dom";

const Unauthorized = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <>
      <div className="main-wrapper error-wrapper">
        <div className="error-box">
          <img className="img-fluid" src={error02} alt="Logo" />
          <h3>
            <img className="img-fluid mb-0" src={dangericon} alt="Logo" />{" "}
            Acceso no autorizado
          </h3>
          <Link to="/login" className="btn btn-primary">
          Iniciar sesion
          </Link>
        </div>
      </div>
    </>
  );
};

export default Unauthorized;
